import { Component } from '@angular/core';

@Component({
  selector: 'app-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.less'],
})
export class DataCardComponent {

  age = new Number;

  ngOnInit(): void {
    this.age = Math.floor(((Date.now() - new Date('June 25, 1995 00:00:00').getTime()) / (1000 * 3600 * 24))/365);
}

}
